import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpResponse
} from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { tap } from 'rxjs/operators';



import { LoadingService } from './loading.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
    constructor(private loadingService: LoadingService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        //let loadingRef: LoadingOverlayRef;
        //this.loadingService.requestStarted();

        // This is a little hacky and related to change detection (ExpressionChangedAfterItHasBeenCheckedError).
        // More informations here:
        // https://blog.angularindepth.com/everything-you-need-to-know-about-the-expressionchangedafterithasbeencheckederror-error-e3fd9ce7dbb4

        //Promise.resolve(null).then(() => loadingRef = this.loadingService.open());

        return next.handle(req).pipe(
            tap(
                req => {
                    if (req instanceof HttpResponse) {
                        //loadingRef.close();
                       // this.loadingService.requestEnded();

                    }
                },
                err => {
                    // loadingRef.close();
                   // this.loadingService.requestEnded();
                }
            )
        );
    }


    handleError(error) {
        console.log(error);
        let errorMessage = '';

        if (error.error instanceof ErrorEvent) {

            // client-side error
           // this.loadingService.requestEnded();

            errorMessage = `Error: ${error.error.message}`;

        } else {

            // server-side error
            this.loadingService.requestEnded();

            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;

        }

        return throwError(errorMessage);

    }
}
